import { AccountType, GenericObject, copyFields } from '@synergy/models';

export class Account {
    public id!: number;
    public name!: string;
    public categoryIds!: number[];
    public isContractPartner!: boolean;
    public isChargingSupplier!: boolean;
    public type!: AccountType;
    public termsOfPayment?: string;
    public termsOfDelivery?: string;
    public lastCheckedDate!: Date;
    public accountNeedsToBeChecked?: boolean;
    public lastCheckedExpirationThresholdInDays!: number | null;

    public static fromPlainObject(object: GenericObject): Account {
        const account = new Account();

        copyFields(object, account);

        return account;
    }
}
